angular.module('picmonicng').directive('learnPathway', [
  '$state',
  '$filter',
  'UserService',
  'PicmonicQueue',
  function ($state, $filter, UserService, PicmonicQueue) {
    return {
      restrict: 'A',
      scope: {
        target: '=learnPathway',
        learnMethod: '@',
      },
      link: function (scope, element, attrs) {
        element.bind('click', function (e) {
          scope.$apply(function () {
            var pathway_slug = $filter('slugify')(scope.target.name) + '-' + scope.target.pathway_id;
            if (!UserService.user || !UserService.user.user_id) {
              send_ga('event', 'Pathways', 'No Account Modal');
              UserService.showRegisterModal('register', '/quiz/pathway/' + pathway_slug);
            } else {
              if (scope.learnMethod == 'quiz') {
                PicmonicQueue.goToQuiz(pathway_slug, 'pathway', scope.target.total_facts, scope.target.name);
              }
            }
          });
        });
      },
    };
  },
]);
